import gsap from 'gsap'
import { lerp } from '../vendor/utils'

export default class CursorFollow
{
  constructor(view,params)
  {
    this.DOM = {}
    this.DOM.view = view
    if(typeof params != 'undefined' && typeof params.type != 'undefined' && params.type == 'basic') {
      this.DOM.cursor = document.querySelector('.fxCursorBasic')
    } else {
      this.DOM.cursor = document.querySelector('.fxCursor')
    }

    this.DOM.hovers = this.DOM.view.querySelectorAll('a')
    this.CAN_MOUSEMOVE = true
    this.currentPosition = { x : 0, y : 0 }
    this.newPosition = { x : 0 , y : 0 }
    this.dimensions = 124
    this.inertia = 4
    this.raf = false
    this.containerPosition = { y : 0 }
    //? Fns
    this.fnMousemove = this.mousemove.bind(this)
    this.events()
    this.rendering()
  }

  destroy()
  {
    window.removeEventListener('mousemove',this.fnMousemove)
    cancelAnimationFrame(this.raf)
    gsap.set(this.DOM.cursor, { clearProps:'all' })
  }

  events()
  {
    window.addEventListener('mousemove',this.fnMousemove)
    this.DOM.view.addEventListener('mouseenter',()=>{
      gsap.to(this.DOM.cursor,
        {
          scale:1,
          duration:.5,
          ease:'quint.out'
        }
      )
    })
    this.DOM.view.addEventListener('mouseleave',()=>{
      gsap.to(this.DOM.cursor,
        {
          scale:0,
          duration:.5,
          ease:'quint.out'
        }
      )
    })
    for(let hover of this.DOM.hovers) {
      hover.addEventListener('mouseenter',()=>{
        gsap.to(this.DOM.cursor,
          {
            scale:1.1,
            duration:.5,
            ease:'quint.out'
          }
        )
      })
      hover.addEventListener('mouseleave',()=>{
        gsap.to(this.DOM.cursor,
          {
            scale:1,
            duration:.5,
            ease:'quint.out'
          }
        )
      })
    }
  }

  mousemove(e)
  {
    this.currentPosition.x = e.clientX
    this.currentPosition.y = e.clientY
  }

  rendering()
  {

    const watcher = ()=> {
      if(this.CAN_MOUSEMOVE === true) {
        this.containerPosition.y = this.DOM.view.getBoundingClientRect().y
        this.newPosition.x = lerp(this.currentPosition.x, this.newPosition.x,.8)
        this.newPosition.y = lerp(this.currentPosition.y, this.newPosition.y,.8)
        gsap.set(this.DOM.cursor  , { x : this.newPosition.x - (this.dimensions / 2) , y : this.newPosition.y - (this.dimensions / 2) })
      }
      this.raf = requestAnimationFrame(watcher);
    }
    watcher()
  }
}
